import { useState, useEffect } from 'react';
import { DashboardLayout } from '../components/layout/DashboardLayout';
import { Card } from '../components/ui/Card';
import { getProperties } from '../services/properties';
import { useNavigate } from 'react-router-dom';
import { Property } from '../types/user';
import { HomeIcon } from '@heroicons/react/24/outline';
import toast from 'react-hot-toast';

export const ReportsPage = () => {
  const [properties, setProperties] = useState<Property[]>([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchProperties = async () => {
      try {
        const data = await getProperties();
        setProperties(data);
      } catch (error) {
        console.error('Error al cargar propiedades:', error);
        toast.error('Error al cargar las propiedades');
      } finally {
        setLoading(false);
      }
    };

    fetchProperties();
  }, []);

  if (loading) {
    return (
      <DashboardLayout>
        <div className="flex items-center justify-center h-full">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-red-500" />
        </div>
      </DashboardLayout>
    );
  }

  return (
    <DashboardLayout>
      <div className="space-y-6">
        <h1 className="text-2xl font-bold">Informes de Propiedades</h1>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {properties.map((property) => (
            <Card 
              key={property.id}
              onClick={() => navigate(`/property/${property.id}/report`)}
              className="cursor-pointer transform transition-all hover:scale-105"
            >
              <div className="p-6">
                <div className="flex items-center space-x-4">
                  <div className="p-3 bg-red-100 rounded-lg">
                    <HomeIcon className="h-6 w-6 text-red-600" />
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold">{property.name}</h3>
                    <p className="text-sm text-gray-500">{property.location}</p>
                  </div>
                </div>
                
                <div className="mt-4 grid grid-cols-2 gap-4">
                  <div>
                    <p className="text-sm text-gray-500">Facturación</p>
                    <p className="text-lg font-semibold">{Math.round(property.stats.revenue).toLocaleString()}€</p>
                  </div>
                  <div>
                    <p className="text-sm text-gray-500">Ocupación</p>
                    <p className="text-lg font-semibold">{Math.round(property.stats.occupancyRate)}%</p>
                  </div>
                </div>
              </div>
            </Card>
          ))}
        </div>
      </div>
    </DashboardLayout>
  );
};